<template>
  <div class="card-export" :class="{ 'card-export-close': !isExpand }">
    <div class="header">
      <div class="header-left">
        <img :src="require('../assets/export-file.png')" />
        <div class="title-block">
          <span class="title">Export File</span>
          <span class="desc"> {{ getDesc }}</span>
        </div>
      </div>
      <div class="header-right">
        <i
          class="fas fa-chevron-down"
          v-if="isExpand"
          @click="isExpand = !isExpand"
        >
        </i>
        <i class="fas fa-chevron-up" v-else @click="isExpand = !isExpand"></i>
        <i class="fas fa-times" @click="closeExportCard"></i>
      </div>
    </div>
    <div v-if="isExpand" class="content-list">
      <div v-for="(item, index) in exportQueue" :key="item._id" class="content">
        <div class="row">
          <div class="col-7">
            <div class="name-block">
              <div class="file-name">{{ item.filename }}</div>
            </div>
          </div>
          <div class="col-5">
            <div class="action-block text-right">
              <div
                v-if="item.status === 'new' || item.status === 'generating'"
                class="action-generating"
                :disabled="
                  item.status === 'new' || item.status === 'generating'
                "
              >
                <i class="fas fa-circle-notch spinner text-primary-blur"></i>
                <span class="action-text text-primary-blur">
                  Generating...</span
                >
              </div>

              <div v-if="item.status === 'generated'" class="action-download">
                <button
                  class="btn btn-sm btn-primary"
                  @click="downloadFile(item, index)"
                >
                  <i
                    class="fas fa-circle-notch spinner"
                    v-if="item.isDownload"
                  ></i>
                  Download
                </button>
              </div>

              <div
                v-if="item.status === 'downloaded'"
                class="action-download-again"
              >
                <div class="download-again" @click="downloadFile(item, index)">
                  <i class="fas fa-rotate text-primary"></i>
                  <span class="action-text">Download again</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serviceRoutes from '../service-routes'
export default {
  name: 'ExportCard',
  emits: ['closeExportCard', 'reload'],
  props: {
    exportData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isExpand: true,
      exportQueue: []
    }
  },
  watch: {
    exportData: function (val) {
      this.exportQueue = val
    }
  },
  mounted() {
    this.exportQueue = JSON.parse(JSON.stringify(this.exportData))
  },
  computed: {
    getDesc() {
      return this.exportQueue.filter((v) => v.status === 'generating').length >
        0
        ? 'Generating 1 item...'
        : 'Ready to download'
    }
  },
  methods: {
    closeExportCard() {
      this.$emit('closeExportCard')
    },
    async downloadFile(item, index) {
      const { status, _id } = item
      if (status === 'generated' || status === 'downloaded') {
        try {
          this.exportQueue = this.exportQueue.map((v, i) => {
            return {
              ...v,
              isDownload: i === index
            }
          })
          await serviceRoutes.downloadExportFile(_id)
        } catch (error) {
          console.error(error)
        }
        this.exportQueue[index].isDownload = false
        this.$emit('reload')
      }
    }
  }
}
</script>

<style scoped>
.card-export {
  width: 431px;
  background: #ffffff;
  border: 1px solid #f1f2f6;
  box-sizing: border-box;
  box-shadow: 0px 5px 30px rgba(146, 153, 184, 0.194);
  border-radius: 15px 15px 0px 0px;
  margin-left: 67% !important;
  position: fixed;
  bottom: 0;
  right: 0;
  opacity: 1;
  z-index: 999;
}

@media screen and (max-width: 575px) {
  .card-export {
    width: 100%;
  }
}

.card-export .header {
  display: flex;
  justify-content: space-between;
  padding: 25px;
  height: 88px;
  box-shadow: 0px 5px 30px rgba(146, 153, 184, 0.194);
}

.card-export .header .header-left {
  display: flex;
}

.card-export .header .header-left .title-block {
  margin-left: 1rem;
  display: flex;
  flex-flow: column;
  justify-content: center;
}

.card-export .header .header-left .title-block .title {
  font-size: 16px;
  font-weight: 500;
  color: #272b41;
}

.card-export .header .header-left .title-block .desc {
  font-size: 14px;
  color: #9299b8;
}

.card-export .header .header-right {
  color: #9299b8;
  display: flex;
  column-gap: 1rem;
}

.card-export .header .header-right i {
  cursor: pointer;
}

.card-export .content-list {
  padding: 0 25px 25px 25px;
  width: 431px;
  height: 220px;
  overflow-y: scroll;
  overflow-x: hidden;
}

@media screen and (max-width: 575px) {
  .card-export .content-list {
    padding: 0 20px;
    width: 100%;
  }
}

.card-export .content-list .content {
  height: 70px;
}

.card-export .content-list .content .name-block {
  display: flex;
  align-items: center;
}

.card-export .content-list .content .name-block img {
  width: 20px;
}

.card-export .content-list .content .name-block .file-name {
  color: #5a5f7d;
  margin-left: 1rem;
}

.card-export .content-list .content .action-block .action-text {
  color: #2196f3;
  font-size: 13px;
  font-weight: 500;
  margin-left: 0.5rem;
}

.card-export .content-list .content .action-block .action-download-again {
  cursor: pointer;
}

.card-export .content-list .content:not(:last-child) {
  border-bottom: 1px solid #f1f2f6;
}

@media screen and (min-width: 575px) {
  .card-export-close {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }
}

.text-primary-blur {
  color: #79c0f8 !important;
}
</style>
